import { Component, EventEmitter, Output, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PackagesService } from '../../services/payments/packages/packages.service';
import { PackagesResponse } from '../../models/payment/packagesResponse';
import { PaymentService } from '../../services/payments/payment/payment.service';
import { CreatePayNowRequest } from '../../models/payment/createPayNowRequest';
import { PaymentGatewayResponse } from '../../models/payment/paymentGatewayResponse.model';
import { Store } from '@ngxs/store';
import { UserSelectors } from '../../states/user/user-selector';
import { AuthService } from '../../services/account/auth.service';
import { filter, switchMap, take } from 'rxjs/operators';
import { ButtonModule } from 'primeng/button';
import { ContactPurpose } from '../../models/enums/contactUs';
import { ClarityCallPopupComponent } from '../../shared/components/clarity-call-popup/clarity-call-popup.component';

@Component({
  selector: 'app-expert-checkout',
  standalone: true,
  imports: [CommonModule, ButtonModule, ClarityCallPopupComponent],
  templateUrl: './expert-checkout.component.html',
  styleUrl: './expert-checkout.component.scss'
})
export class ExpertCheckoutComponent implements OnInit {
  @Output() paymentComplete = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
  @Output() loaded = new EventEmitter<void>();

  showClarityCallDialog: boolean = false;
  ContactPurpose = ContactPurpose;

  packageDetails: PackagesResponse | null = null;
  loading: boolean = true;
  paymentInProgress: boolean = false;

  get baseAmount(): number {
    return this.packageDetails?.amount || 125;
  }

  get gstAmount(): number {
    return +(this.baseAmount * 0.18).toFixed(2);
  }

  get totalAmount(): number {
    return +(this.baseAmount + this.gstAmount).toFixed(2);
  }

  constructor(
    private packagesService: PackagesService,
    private paymentService: PaymentService,
    private store: Store,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.packagesService.getPackageBySystemAssignedName('Expert Session + 5 College Applications').subscribe({
      next: (res) => {
        this.packageDetails = res;
        this.loading = false;
        this.loaded.emit();
      },
      error: (err) => {
        console.error('Failed to load package', err);
        this.loading = false;
        this.loaded.emit();
      }
    });
  }

  onContinue() {
    if (!this.packageDetails) return;
    this.paymentInProgress = true;

    const baseUrl = window.location.origin + '/portal/direct-apply/payment-review';

    this.store.select(UserSelectors.getUser).pipe(
      filter(user => !!user?.id),
      take(1),
      switchMap(user => this.authService.getUserByid(user.id))
    ).subscribe({
      next: (userDetails) => {
        const fullName = `${userDetails.firstName} ${userDetails.lastName || ''}`.trim();
        const cleanPhone = userDetails.phoneNumber
          ? userDetails.phoneNumber.replace(/\D/g, '').substring(0, 10)
          : '0000000000';

        const request: CreatePayNowRequest = {
          name: fullName || "Direct Expert Session User",
          userEmail: userDetails.email || "user@example.com",
          phoneNumber: cleanPhone,
          amount: this.totalAmount,
          transactionType: "SALE",
          sourceUrl: baseUrl, // Function isme /{txnId}?success=true append karega
          packageId: this.packageDetails?.id,
          billingAddress: {
            userId: userDetails.id,
            billAddress: "N/A"
          },
          metaData: []
        };

        this.paymentService.payNow(request).subscribe({
          next: (response: PaymentGatewayResponse) => {
            if (response.redirectUri && response.redirectUri.trim() !== '') {
              window.location.href = response.redirectUri;
            } else {
              this.paymentInProgress = false;
              this.paymentComplete.emit();
            }
          },
          error: (err: any) => {
            this.paymentInProgress = false;
            console.error('Payment failed', err);
            alert('Payment initiation failed. Please try again.');
          }
        });
      },
      error: (err) => {
        this.paymentInProgress = false;
        console.error('Failed to get user details', err);
        alert('Failed to get user details. Please try again.');
      }
    });
  }

  onCancel() {
    this.cancel.emit();
  }
}
